import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BASE}/api`;
export const apiClient = axios.create({ baseURL: API, timeout: 20000 });

// Attach token to every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('wss_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [setupRequired, setSetupRequired] = useState(false);

  const fetchMe = async () => {
    const token = localStorage.getItem('wss_token');
    if (!token) { setUser(null); return; }
    try {
      const r = await apiClient.get('/auth/me');
      setUser(r.data);
    } catch (e) {
      localStorage.removeItem('wss_token');
      setUser(null);
    }
  };

  const refreshSetup = async () => {
    try {
      const r = await apiClient.get('/auth/setup-required');
      setSetupRequired(!!r.data.setup_required);
    } catch (e) { console.error('Auth setup probe failed:', e); }
  };

  useEffect(() => {
    (async () => {
      await refreshSetup();
      await fetchMe();
      setLoading(false);
    })();
  }, []);

  const login = async (email, password) => {
    const r = await apiClient.post('/auth/login', { email, password });
    localStorage.setItem('wss_token', r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const setupOwner = async (email, name, password) => {
    const r = await apiClient.post('/auth/setup', { email, name, password });
    localStorage.setItem('wss_token', r.data.access_token);
    setUser(r.data.user);
    setSetupRequired(false);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('wss_token');
    setUser(null);
  };

  const hasPermission = (perm) => {
    if (!user) return false;
    return (user.effective_permissions || []).includes(perm);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setupRequired, login, setupOwner, logout, hasPermission, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext) || { user: null, loading: true, hasPermission: () => false };
